import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SizeGuideComponent } from './size-guide.component';

@NgModule({
  imports: [CommonModule],
  exports: [SizeGuideComponent],
  declarations: [SizeGuideComponent]
})
export class SizeGuideModule {}
